module.exports = __webpack_public_path__ + "static/media/mvc.9ff9599e.png";